export default __webpack_public_path__ + "static/media/Lapis2.b5d3cb0a.jpg";